export const formProductOptionsString = (item) => {
  return item?.productOptions?.map((option) => option.value).join(", ");
};
